(function($){

    var $animation_elements = $('.js-statistic');
    var $window = $(window);
    var numbersAnimationFinished = false;

    function startNumbersAnimation () {
        $('.js-count').each(function () {
            var value = $(this).text();
            $(this).prop('Counter',0).animate({
                Counter: $(this).text()
            }, {
                duration: 1500,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                },
                complete: function() {
                    $(this).text(value);
                }
            });
        });
    }

    function check_if_in_view() {
        var window_height = $window.height();
        var window_top_position = $window.scrollTop();
        var window_bottom_position = (window_top_position + window_height);

        $.each($animation_elements, function() {
            var $element = $(this);
            var element_height = $element.outerHeight();
            var element_top_position = $element.offset().top;
            var element_bottom_position = (element_top_position + element_height);

            if ((element_bottom_position >= window_top_position) &&
                (element_top_position <= window_bottom_position)) {
                if(!numbersAnimationFinished) {
                    startNumbersAnimation();
                }
                numbersAnimationFinished = true;
            }
        });
    }

    $window.on('scroll resize', check_if_in_view);
    $window.trigger('scroll');

})(jQuery);
